import { PortalModule } from "@/@core";

export const module = {
  name: "fseg",
  routes: [
    {
      path: `/`,
      component: () => import("./views/Dashboard.vue"),
      name: "home",
    },
    {
      path: `/documents`,
      component: () => import("./views/documents/Index.vue"),
      auth: { roles: ["WORKER"] },
    },
    {
      path: `/search`,
      component: () => import("./views/search/Index.vue"),
      auth: { roles: ["AGENT"] },
    },
    {
      path: `/signatures`,
      component: () => import("./views/signatures/Index.vue"),
      auth: { roles: ["AGENT"] },
    },
    {
      path: `/worker/signaletic`,
      component: () => import("./views/worker/signaletic/Index.vue"),
      auth: { roles: ["AGENT", "WORKER"] },
    },
  ],
  supportedLocales: ["fr", "nl"],
} as PortalModule;
